import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { TenantUsersDto, TenantsAuthApi } from '@buspro/web/apis';
import { NgxAuthService } from '@corelabs/ng-auth';
import { catchError, lastValueFrom, throwError } from 'rxjs';

export const tenantAuthUserResolver: ResolveFn<TenantUsersDto> = async (_route, _state) => {
  const tenantApi = inject(TenantsAuthApi);
  const ngxAuthService = inject(NgxAuthService);
  const router = inject(Router);

  return await lastValueFrom(
    tenantApi.tenantsAuthControllerAuthenticatedUser().pipe(
      catchError((error) => {
        console.error('Error fetching authenticated user in Tenant Auth User Resolver:', error);

        // Only a refused session signs out (#852) — and then only the session:
        // `localStorage.clear()` here also wiped theme and tenant settings on
        // any network hiccup. A 401 reaching this point already failed a
        // refresh, so the refresh interceptor has signed the user out.
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403) {
          ngxAuthService.logout();
          router.navigate(['/passport/login']);
        }

        return throwError(() => error);
      }),
    ),
  );
};
